import Translate from '../../common/functions/translate';
import { Lang, OfferStatus } from "../enums";
import { faFileExcel, faFileWord, faFileImage, faFile, faFilePdf, faFileArchive } from '@fortawesome/free-solid-svg-icons';
import pdfIcon from "../../assets/images/filetypes/pdf-icon.png";
import xlsIcon from "../../assets/images/filetypes/xls-icon.png";
import wordIcon from "../../assets/images/filetypes/word-doc-icon.png";
import txtIcon from "../../assets/images/filetypes/txt-icon.png";
import zipIcon from "../../assets/images/filetypes/zip-icon.png";
import jpgIcon from "../../assets/images/filetypes/jpg-icon.png";
import pngIcon from "../../assets/images/filetypes/png-icon.png";

export function clone(item) {
  return (
    // return cloned copy so that the item is passed by value instead of by reference
    JSON.parse(JSON.stringify(item))
  );
}

// export function getErrorMessage(error) {
//   if (error.response) {
//     return { message: `${error.response.status} ${error.response.statusText}` }
//   } else {
//     return { message: `${error.message}` }
//   }
// }

export function getErrorMessage(error) {
  if (error.response) {
    if (
      error.response.data &&
      error.response.data.Data &&
      error.response.data.Data.ErrorCode
    ) {
      return { message: Translate(`${error.response.data.Data.ErrorCode}`) };
    }

    if (
      error.response.data &&
      error.response.data.Data &&
      error.response.data.Data.Message
    ) {
      return { message: `${error.response.data.Data.Message}` };
    }

    if (error.response.data) {
      return { message: Translate(`${error.response.data}`) };
    }

    return { message: `${error.response.status} ${error.response.statusText}` };
  } else {
    return { message: Translate(`${error.message}`) };
  }
}

export function getQueryParam(locationSearch: string, paramName: string) {
  const query = new URLSearchParams(locationSearch);
  return query.get(paramName);
}

export function fomatDateAsString(date: Date) {
  return date.getFullYear().toString() + '-' +
    (date.getMonth() < 9 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()) + '-' +
    (date.getDate() < 10 ? '0' + (date.getDate()).toString() : (date.getDate()).toString());
}

export function fomatDateTimeAsString(date: Date) {
  return (date.getDate() < 10 ? '0' + (date.getDate()).toString() : (date.getDate()).toString()) + "." +
    (date.getMonth() < 9 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()) + '.' +
    date.getFullYear().toString() + ' ' +
    ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2) + ":" + ("0" + date.getSeconds()).slice(-2);
}

// export function fomatDateAsString(date: Date) {
//   return (
//     date.getFullYear().toString() +
//     "-" +
//     (date.getMonth() < 9
//       ? "0" + (date.getMonth() + 1).toString()
//       : (date.getMonth() + 1).toString()) +
//     "-" +
//     (date.getDate() < 10
//       ? "0" + date.getDate().toString()
//       : date.getDate().toString())
//   );
//}

export function fomatDatesStringWithLang(date: Date) {
  let lang = localStorage.getItem('lang');
  if (!lang) {
    lang = 'bg';
    //localStorage.setItem('lang', 'bg');
  }
  switch (lang) {
    case "bg":
      return (
        (date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString()) +
        "." +
        (date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString()) +
        "." +
        date.getFullYear().toString() +
        " г."
      );
    case "en":
      return (
        (date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString()) +
        "/" +
        (date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString()) +
        "/" +
        date.getFullYear().toString()
      );
  }
}



export function formatBytes(bytes, decimals) {
  if (bytes === 0) return '0 Bytes';
  var k = 1024,
    dm = decimals <= 0 ? 0 : decimals || 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

//Groups array by objects property and returns object of arrays
export function groupByReturnObject(objectArray, property) {
  return objectArray.reduce(function (acc, obj) {
    var key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
}

//Groups array by objects property and returns array of arrays
export function groupByReturnArray(objectArray, property) {
  return objectArray.reduce(function (acc, obj) {
    var key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, []);
}

// export function enumToDropdownArray(enumName) {
//   let enumAsArray: Array<{ value: number, label: string }> = [];
//   for (var n in enumName) {
//     if (typeof enumName[n] === 'number') {
//       enumAsArray.push({ value: +enumName[n], label: n });
//     }
//   }
//   return enumAsArray;
// }

export function enumToDropdownArray(enumName, withTranslation?: boolean) {
  let enumAsArray: Array<{ value: number, label: string }> = [];
  for (var n in enumName) {
    if (typeof enumName[n] === 'number') {
      enumAsArray.push({ value: +enumName[n], label: withTranslation ? Translate(n) : n });
    }
  }
  return enumAsArray;
}

export function getIconByFileType(fileType: string) {
  switch (fileType.toLowerCase()) {
    case "pdf":
      return pdfIcon;
    case "xls":
    case "xlsx":
      return xlsIcon;
    case "doc":
    case "docx":
      return wordIcon;
    case "txt":
      return txtIcon;
    case "zip":
      return zipIcon;
    case "jpg":
      return jpgIcon;
    case "png":
      return pngIcon;
  }
}

export function getEnumLabel(id: number, enumName: any, withTranslation?: boolean) {
  let enumElement = Object
    .keys(enumName)
    .find(key => enumName[key] === id);

  if (withTranslation) {
    return Translate(enumElement);
  }
  else {
    return enumElement;
  }
}

export function getEnumKeys(enumName: any) {
  return Object.keys(enumName).filter(k => typeof enumName[k as any] === "number");
}

export function getLangId(lang: string) {
  switch (lang) {
    case 'bg':
      return Lang.bg;
    case 'en':
      return Lang.en;
  }
}

export function formatAlarmTime(alarmTime: any) {
  if (typeof alarmTime === 'string') {
    if (alarmTime.length > 8) {
      return fomatTimeWithoutSecondsAsString(new Date(alarmTime));
    } else {
      return fomatTimeStringWithoutSecondsAsString(alarmTime);
    }
  } else {
    return fomatTimeWithoutSecondsAsString(new Date(alarmTime));
  }
}

export function fomatTimeWithoutSecondsAsString(date: Date) {
  return ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2);
}

export function fomatTimeStringWithoutSecondsAsString(time: string) {
  return time.slice(0, 5);
}

export function validateEmail(email) {
  // eslint-disable-next-line
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function getFileIconType(ext?: string) {
  switch (ext) {
    case 'jpg':
    case 'jpeg':
      return faFileImage;
    case 'doc':
    case 'docx':
      return faFileWord;
    case 'xlsx':
    case 'xls':
    case 'csv':
      return faFileExcel;
    case 'pdf':
      return faFilePdf;
    case 'zip':
    case 'rar':
      return faFileArchive;
    default:
      return faFile;
  }
}

export function getFileIconColor(ext?: string) {
  switch (ext) {
    case 'jpg':
    case 'jpeg':
      return '#ff962c';
    case 'doc':
    case 'docx':
      return '#2196f3';
    case 'xlsx':
    case 'xls':
    case 'csv':
      return "#008000";
    case 'pdf':
      return "#ff0000";
    case 'zip':
    case 'rar':
      return '#ff0000';
    default:
      return '#2196f3';
  }
}

export function getOfferStatusColor(offerStatus: OfferStatus, cursor: string = "") {
  switch (offerStatus) {
    case OfferStatus.New:
      return { backgroundColor: "#ffec44", padding: "5px", color: "#000", cursor: cursor }; // ffec44
    case OfferStatus.Expired:
      return { backgroundColor: "#ff9616", padding: "5px", color: "#fff", cursor: cursor };
    case OfferStatus.Accepted:
      return { backgroundColor: "#349646", padding: "5px", color: "#fff", cursor: cursor };
    case OfferStatus.InExecution:
      return { backgroundColor: "#04b4d3", padding: "5px", color: "#fff", cursor: cursor };
    case OfferStatus.Finished:
      return { backgroundColor: "#0059a3", padding: "5px", color: "#fff", cursor: cursor };
    default:
      return { backgroundColor: "#ddd", padding: "5px", color: "#fff", cursor: cursor };
  }
}

export function calculateProductsPrice(array) {
  return array.reduce((acc, curVal) => acc + (curVal.quantity * curVal.price), 0);
}

export function returnSelectionMode(rowData) {
  if (rowData.offerStatusId === OfferStatus.Finished) {
    return "";
  }
  return "multiple";
}

export function checkIsThatTypeToRoot(categoryId, categories, type) {
  let isSearchedType = false;
  let category = categories.find(r => r.id === categoryId);
  if (category) {
    if (category.categoryTypeId === type) {
      isSearchedType = true;
    }
    else {
      if (category.parentId) {
        isSearchedType = checkIsThatTypeToRoot(category.parentId, categories, type);
      }
      else {
        if (category.categoryTypeId === type)
          isSearchedType = true;
      }
    }
  }
  return isSearchedType;
}

export function getAllTypesToRoot(categoryId, categories) {
  let statuses: Array<number> = new Array<number>(0);
  let category = categories.find(r => r.id === categoryId);
  if (category && category.categoryTypeId)
    statuses.push(category.categoryTypeId)
  if (category && category.parentId)
    statuses.push(...getAllTypesToRoot(category.parentId, categories));

  return statuses
}


